<template lang="html">
  <section v-if="results">
    <template v-if="hasPositiveSaving">
      <div class="intro-simulador -resultados container aifs row-around">
        <img src="/static/img/cerdo.webp" class="cerdo">

        <div class="contenedor-textos">
          <h2>{{ $t('newSimulador.resultView.title') }}</h2>
          <h4>{{ $t('newSimulador.resultView.subtitle') }}</h4>
          <p>{{ $t('newSimulador.resultView.subtitle2', { amount: results.best.saving_anual }) }}</p>
          <div class="result-ok row-start" v-if="hasemail">
            <span class="tick">
              <img src="/static/img/tick.svg" alt="">
            </span>
            <h4>{{ $t('newSimulador.resultView.subtitle3') }}</h4>
          </div>
        </div>

        <div class="contenedor-ahorro column-center">
          <h4>{{ $t('newSimulador.resultView.ahorro') }}</h4>
          <h2>{{ results.best.saving_anual }}€</h2>
          <p class="year">{{ $t('newSimulador.resultView.year') }}</p>
          <h4>{{ results.best.fee.name }}</h4>
        </div>

      </div>
      <div class="tarifas-result" v-if="hasPositiveSaving">
        <result-tarifas :results="results.results"></result-tarifas>
      </div>
    </template>

    <template v-else>
      <div class="intro-simulador container aifs row-start">
        <img src="/static/img/cerdo.webp" class="cerdo">
        <div class="contenedor-textos__without-savings">
          <h2>{{ $t('newSimulador.resultView.withoutSavings.title') }}</h2>
          <h4>{{ $t('newSimulador.resultView.withoutSavings.subtitle') }}</h4>
          <p v-html="$t('newSimulador.resultView.withoutSavings.subtitle2')"></p>
          <h4>{{ $t('newSimulador.resultView.withoutSavings.subtitle3') }}</h4>
        </div>
      </div>
    </template>

    <banner-beneficios></banner-beneficios>
  </section>
</template>

<script lang="js">
import { mapGetters } from 'vuex';
import resultTarifas from '@/components/view-parts/simulador/result-tarifas';
import bannerBeneficios from '@/components/parts/banner-beneficios';

export default {
  name: 'result-view',
  props: ['results', 'hasemail'],
  components: {
    "result-tarifas": resultTarifas,
    "banner-beneficios": bannerBeneficios,
  },
  computed: {
    ...mapGetters({
      precios: 'getPrecios'
    }),
    hasPositiveSaving() {
        if (!this.results || !this.results.best || !this.results.best.saving_anual) {
            return false;
        }
        // Convertir formato español (coma) a número
        const saving = Number(
            this.results.best.saving_anual.replace(/\./g, '').replace(',', '.')
        );
        return !Number.isNaN(saving) && saving > 0;
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';

.tarifas-result {
  padding-top: 50px;
  padding-bottom: 80px;
  /* background: linear-gradient(to bottom, #f9f7fc, #f9f7fc); */
}

.contenedor-textos {
  display: inline-block;
  max-width: 450px;
  text-align: left;
  margin-right: 50px;

  &__without-savings {
    max-width: 100%;
    text-align: left;
    margin-right: 50px;
    margin-left: 50px;

    h3 {
      margin-top: 10px;
      font-size: 40px;
      margin-bottom: 0;
      line-height: .9em;
    }

    p {
      margin-top: 20px;
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 400;
    }
  }

  h3 {
    margin-top: 10px;
    font-size: 40px;
    margin-bottom: 0;
    line-height: .9em;
  }

  h3+p {
    margin-top: 0;
    margin-bottom: 20px;
  }

  p.tip {
    font-size: 14px;
    margin-top: 0;
    margin-bottom: 0;
  }

  p {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 400;
  }

}

.contenedor-ahorro {
  width: 310px;
  height: 310px;
  border-radius: 50%;
  background: $degree;
  text-align: center;
  margin-left: 50px;
  position: relative;
  margin-top: 0;

  h4 {
    text-transform: uppercase;
    color: white;
  }

  h2 {
    text-align: center;
    color: white;
    margin-bottom: 10px;
  }

  .year {
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    color: white;
  }

  .btn {
    position: absolute;
    bottom: -70px;
    left: 50%;
    transform: translateX(-50%) translateY(100px);
    opacity: 0;
    animation-name: showbuttoncontratar;
    animation-duration: 1s;
    animation-delay: 1s;
    -webkit-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }
}

@keyframes showbuttoncontratar {
  to {
    opacity: 1;
    transform: translateX(-50%);
  }
}

.result-ok {
  position: relative;
  z-index: 3;
  margin-bottom: 30px;
  margin-top: 15px;

  .tick {
    background: $orange;
    width: 40px;
    height: 40px;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    border-radius: 50%;
    margin-right: 10px;
    transform: translateY(-10px);
  }

  h4 {
    max-width: calc(100% - 60px);
  }
}

@media screen and (max-width: 1400px) {
  .contenedor-ahorro {
    margin-left: 0;
  }
}

@media screen and (max-width: 900px) {

  .contenedor-textos {
    margin-right: 20px;
    max-width: calc(100% - 270px);
    &__without-savings {
      margin-left: 20px;
      margin-right: 20px;
    }
  }

  .contenedor-ahorro {
    width: 250px;
    height: 250px;

    h2 {
      font-size: 50px;
    }

    h4 {
      font-size: 18px;
    }

    h2 {
      line-height: .9em;
    }
  }

}


@media screen and (max-width: 767px) {
  .intro-simulador {
    align-items: center;
    justify-content: center;
    padding-bottom: 0px;

    .cerdo {
      display: inline-block;
      max-width: 200px;
      right: 0;
      left: auto;
      top: 0;
      bottom: auto;
      display: none;
    }
  }

  .contenedor-textos {
    max-width: 100%;
    width: 100%;
    margin-right: 0;

    &__without-savings {
      margin-left: 0;
      margin-right: 0;
      p {
        margin-bottom: 8px;
        margin-top: 8px;
      }
    }

    p {
      margin-bottom: 20px;
    }
  }

  .result-ok {
    margin-bottom: 0;

    h4 {
      font-size: 20px;
    }
  }

  .contenedor-ahorro {
    margin-top: 30px;
    -webkit-order: 4;
    -moz-order: 4;
    -ms-order: 4;
    -o-order: 4;
    order: 4;
    margin-bottom: 80px;
  }
}


@media screen and (max-width: 450px) {
  .intro-simulador h2 {
    font-size: 38px;
  }

  .contenedor-ahorro {
    width: 100%;
    border-radius: 0;
    height: auto;
    padding: 40px 0;
    margin-top: 20px;

    h2 {
      font-size: 55px;
    }
  }

  .contenedor-textos p {
    margin-bottom: 0;
    margin-top: 0;
  }

  .contenedor-textos h3+p {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/simulador/result-view.vue